<template>

    <form ref="questaoperguntaresposta-form-create" v-on:submit.prevent="executeCreate(model)" novalidate>

        <div class="row">

            <div class="form-group col-md-12">
                <label for="resposta">Resposta</label>
                <br />
                <em>Caso você precise subir vídeos, favor não ultrapassar 2MB por vídeos</em>
                <div v-if="podeDigitarResposta">
                    <textarea required v-model="model.resposta" v-htmleditor></textarea>
                </div>
                
            </div>
            <div class="form-group col-md-12">
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" name="ehCorreta" class="custom-control-input" v-model="model.ehCorreta">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description"> Correta?</span>
                </label>
            </div>
        </div>
        <button type="button" class="btn btn-success float-right" @click="executeCreate(model)">
            <span>Salvar</span>
        </button>
        <br /><br />
    </form>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'

    export default {
        name: "questaoperguntaresposta-form-create",
        mixins: [base],
        props: { questaoPerguntaId: Number },
        data: () => ({

            model: {},

            form: "questaoperguntaresposta-form-create",
            podeDigitarResposta: false,

            resources: {
                create: 'questaoperguntaresposta',
            },
           
        }),

        methods: {

            executeCreate: function (model) {

                if (this.formValidate() == false)
                    return;

                model.questaoPerguntaId = this.questaoPerguntaId;
                new Api(this.resources.create).post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.defaultSuccessResult('Registro inserido com sucesso');
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            formValidate: function () {
                var $form = this.$refs[this.form];
                $form.classList.add("was-validated");
                return $form.checkValidity();
            },

            onBack: function () {
                this.$emit('on-back')
            }
        },        
        mounted() {
            //console.log("Valor pode Digitar", this.podeDigitarsss);            
            setTimeout(() => { this.podeDigitarResposta = true; }, 1000);
        }
    };
</script>

